<template lang="pug">

table.ui.very.basic.fixed.table

    thead
        tr
            th Erstellt am
            th Gültig bis
            th

    tbody

        tr(
            is='table-row'
            v-for='hashlinkModel in hashlinkModels'
            v-bind:key='hashlinkModel.id'
            v-bind:hashlink-model="hashlinkModel"
        )


</template>

<script>
    import TableRow from './hashlink-table/TableRow'

    export default {
        name: 'product-files-thumbnail-hashlink-table-component',

        components: { TableRow },

        props: {

            hashlinkModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
